import c from "react";
import { getIconColor as h } from "./iconfont.es5470.js";
import p from "./iconfont.es5471.js";
const r = {
  display: "block"
}, g = ({ size: a = 16, useVw: n, useRem: t, color: o, withColor: l, removeClassName: e, disableSSR: v, style: i, ...d }) => {
  const m = i ? { ...r, ...i } : r;
  return /* @__PURE__ */ c.createElement(p, { disableSSR: v }, /* @__PURE__ */ c.createElement("svg", { "data-icon-id": "24px-zizhanghaoguanli", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (t ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (t ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: m, fill: "none", ...d }, /* @__PURE__ */ c.createElement(
    "g",
    {
      className: e ? "" : "24px-å­è´¦å·ç®¡ç"
    },
    /* @__PURE__ */ c.createElement(
      "path",
      {
        clipRule: "evenodd",
        className: e ? "" : "normal",
        d: "M15.795 4.569a1.923 1.923 0 0 0-1.923-1.924h-3.744A1.923 1.923 0 0 0 8.204 4.57v1.82H6.758A2.298 2.298 0 0 0 4.46 8.688v4.442H3.388a1.923 1.923 0 0 0-1.923 1.924v3.744c0 1.062.86 1.923 1.923 1.923h3.744a1.923 1.923 0 0 0 1.924-1.923v-3.745a1.923 1.923 0 0 0-1.924-1.923H6.06V8.687c0-.385.313-.697.698-.697h1.446v.323c0 1.062.861 1.923 1.924 1.923h3.744a1.923 1.923 0 0 0 1.923-1.923V7.99h1.447c.385 0 .697.312.697.697v4.442h-1.072a1.923 1.923 0 0 0-1.923 1.924v3.744c0 1.062.861 1.923 1.923 1.923h3.745a1.923 1.923 0 0 0 1.923-1.923v-3.745a1.923 1.923 0 0 0-1.923-1.923H19.54V8.687a2.298 2.298 0 0 0-2.298-2.297h-1.447V4.569Zm-1.923-.324c.178 0 .323.145.323.324v3.744a.323.323 0 0 1-.323.323h-3.744a.323.323 0 0 1-.324-.323V4.569c0-.179.145-.324.324-.324h3.744Zm6.74 10.484c.178 0 .323.145.323.324v3.744a.323.323 0 0 1-.323.323h-3.744a.323.323 0 0 1-.324-.323v-3.745c0-.178.145-.323.323-.323h3.745Zm-13.156.324a.323.323 0 0 0-.324-.324H3.388a.323.323 0 0 0-.323.324v3.744c0 .178.145.323.323.323h3.744a.323.323 0 0 0 .324-.323v-3.745Z",
        fillRule: "evenodd",
        fill: l ? h(o, 0, "#262933") : "#262933",
        datafollowfill: l ? h(o, 0, "#262933") : "#262933"
      }
    )
  )));
}, u = g;
export {
  u as default
};
